import { useTranslations } from "next-intl";
import ClassicLoader from "@/components/common/classic-loader";
import { Button } from "@/components/ui/button";
import { useDiscountCode } from "@/features/cart/hooks/use-discount-code";
import type { CartStoreType } from "@/features/cart/types/cart-store-type";

export const RemoveDiscount = ({
  className,
  type,
}: {
  className?: string;
  type?: CartStoreType;
}) => {
  const t = useTranslations();
  const { handleRemove, isRemoveLoading } = useDiscountCode(type);

  return (
    <div className={className}>
      <Button
        className="h-auto min-h-0 p-0 font-bold"
        disabled={isRemoveLoading}
        onClick={handleRemove}
        variant="link"
      >
        {t("cart.removeDiscount")}
        {isRemoveLoading && (
          <ClassicLoader className="ml-2 h-4 w-4 animate-spin" />
        )}
      </Button>
    </div>
  );
};
